export const dev_major = 1;
export const dev_minor = 5;
export const dev_patch = 70;
export const stage_major = 1;
export const stage_minor = 5;
export const stage_patch = 0;
export const master_major = 1;
export const master_minor = 5;
export const master_patch = 87;
